import React from 'react';
import PropTypes from 'prop-types';
import { Bar, Line, Pie, Doughnut } from 'react-chartjs-2';
import { ChartContainer } from './components/ChartStyles';
import { useChart } from './hooks/useChart';

const Chart = ({ type, data, options, height, ...props }) => {
  const { chartRef, combinedOptions } = useChart({ type, options });

  const renderChart = () => {
    switch (type) {
      case 'line':
        return <Line data={data} options={combinedOptions} ref={chartRef} />;
      case 'pie':
        return <Pie data={data} options={combinedOptions} ref={chartRef} />;
      case 'doughnut':
        return <Doughnut data={data} options={combinedOptions} ref={chartRef} />;
      case 'bar':
      default:
        return <Bar data={data} options={combinedOptions} ref={chartRef} />;
    }
  };

  return (
    <ChartContainer height={height} {...props}>
      {renderChart()}
    </ChartContainer>
  );
};

Chart.propTypes = {
  type: PropTypes.oneOf(['bar', 'line', 'pie', 'doughnut']),
  data: PropTypes.object.isRequired,
  options: PropTypes.object,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Chart.defaultProps = {
  type: 'bar',
  height: '300px',
  options: undefined,
};

export default Chart;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Chart/Chart.jsx